import script from "./PlatformGoodsDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatformGoodsDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./PlatformGoodsDrawer.vue?vue&type=style&index=0&id=442da606&lang=scss"
import "./PlatformGoodsDrawer.vue?vue&type=style&index=1&id=442da606&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-442da606"]])

export default __exports__